import {
  Request
} from '../../common/request.js'

// 省直辖市列表(下拉框)
const getProvincesApi = obj => Request('App/FinancialProduct/provinces', 'GET', obj)

// 搜索产品
const getSearchApi = obj => Request('App/FinancialProduct/index', 'GET', obj)

//app用户存款计划列表
const getUserDepositPlanList = obj => Request('App/UserDepositPlan/index', 'GET', obj)

//app用户添加存款计划
const addUserDepositPlan = obj => Request('App/UserDepositPlan/store', 'POST', obj)

//我的风险测评档案
const getRiskAssessmentList = obj => Request('App/UserRiskAssessment/show', 'GET', obj)

//更新风险 评测
const updataRiskAssessment = obj => Request('App/UserRiskAssessment/insertOrUpdate', 'POST', obj)


//获取档案结果页
const getUserDepositPlanDetails = obj => Request('App/UserDepositPlan/computeResult', 'GET', obj)


// 用户点击计算存款计划
const getUserDepositPlanCompute = obj => Request('App/UserDepositPlan/compute', 'POST', obj)

export default {
  getProvincesApi,
  getSearchApi,
  getUserDepositPlanList,
  addUserDepositPlan,
  getRiskAssessmentList,
  updataRiskAssessment,
  getUserDepositPlanDetails,
  getUserDepositPlanCompute,

}



// WEBPACK FOOTER //
// ./src/api/mainApi/index.js